import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";
// mui
import {
  Drawer,
  List,
  ListItem,
  Button,
  Typography,
  IconButton,
  useTheme,
  useMediaQuery,
  Box,
  Tooltip,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { ReactComponent as UploadIcon } from "./assets/imgs/oui_users.svg";
// components
// assets
import { ReactComponent as LogoutIcon } from "./assets/imgs/signout.svg";
import { ReactComponent as SubscriptionsIcon } from "./assets/imgs/subscription.svg";
import styles from "./assets/scss/side-panel.module.scss";
import sharedStyles from "assets/scss/_shared.module.scss";
// types
import { IProps } from "./types/side-panel";
// enums

const SidePanel: React.FC = () => {
  const theme = useTheme();
  const app = useSelector((state: any) => state.app?.allData || {});
  const selectedEntity = app.entities_info?.find(
    (entity: any) => entity.id === app.entityId
  );

  const navigate = useNavigate();
  const location = useLocation();

  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => setMobileOpen(!mobileOpen);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const menuItems: IProps[] = [
    { label: `${selectedEntity?.name || "Entity"}` },
    {
      label: "Entities",
      iconBefore: <UploadIcon />,
      path: "/Entities",
    },
    {
      label: "Subscriptions",
      iconBefore: <SubscriptionsIcon width={20} height={20} />,
      path: "/subscriptions/",
    },
    { label: "Logout", iconBefore: <LogoutIcon />, path: "/logout/" },
  ];

  const handleClick = (path: string) => {
    if (path === "/logout/") {
      localStorage.clear();
      navigate("/");
      window.location.reload();
    } else if (path === "/entities/") {
      navigate("/entities/");
    } else if (path) {
      navigate(path);
    }
  };

  const renderMenuItems = () => (
    <List>
      {menuItems.map((item, index) => (
        <React.Fragment key={index}>
          <ListItem
            key={index}
            component="li"
            sx={{
              marginTop: item.path ? "3px" : "25px",
              marginBottom: item.path ? 0 : "20px",
              ":hover": {
                backgroundColor: item.path
                  ? theme.custom.neutralColors.color2
                  : "transparent",
              },
              backgroundColor:
                location.pathname === item.path
                  ? theme.custom.neutralColors.color13
                  : "transparent",
            }}
            className={styles.menuItems}
          >
            {item.path ? (
              <Button
                onClick={() => handleClick(item.path || "#")}
                fullWidth
                sx={{
                  textAlign: "left",
                  justifyContent: "flex-start",
                }}
              >
                {item.iconBefore && (
                  <span
                    style={{ marginRight: "8px" }}
                    className={sharedStyles["icon"]}
                  >
                    {item.iconBefore}
                  </span>
                )}
                <Typography
                  sx={{
                    fontSize: "12px",
                    fontFamily: "Cairo",
                    flex: 1,
                    textAlign: "left",
                    color: theme.custom.font.black,
                    ":hover": {
                      color: theme.custom.font.light,
                    },
                  }}
                >
                  {item.label}
                </Typography>
                {item.iconAfter && (
                  <span
                    style={{ marginLeft: "8px" }}
                    className={sharedStyles["icon"]}
                  >
                    {item.iconAfter}
                  </span>
                )}
              </Button>
            ) : (
              <Box
                className={styles.entityNameContainer}
                sx={{ position: "relative" }}
              >
                <div
                  className={styles.iconContainer}
                  style={{
                    backgroundColor: theme.palette.secondary.main,
                  }}
                >
                  <Typography
                    className={styles.iconText}
                    sx={{
                      color: theme.custom.neutralColors.color11,
                    }}
                  >
                    {`${app.first_name?.[0] || ""}${app.last_name?.[0] || ""}`}
                  </Typography>
                </div>
                <div className={styles["name-container"]}>
                  <Typography
                    style={{
                      color: theme.custom.font.black,
                      lineHeight: 1.25,
                    }}
                  >
                    {item.label}
                  </Typography>
                </div>
              </Box>
            )}
          </ListItem>
        </React.Fragment>
      ))}
    </List>
  );

  return (
    <>
      {isMobile && !mobileOpen && (
        <IconButton
          onClick={handleDrawerToggle}
          className={styles["menu-icon"]}
          sx={{
            boxShadow:
              "var(--mui-shadows-6, 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12))",
            backgroundColor: theme.palette.primary.dark,
          }}
        >
          <MenuIcon
            sx={{
              fill: "#fff",
            }}
          />
        </IconButton>
      )}
      {isMobile ? (
        <Drawer
          anchor="left"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true,
          }}
        >
          <div style={{ width: 250 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                width: "20px",
                height: "20px",
                position: "fixed",
                left: "225px",
                top: "20px",
                zIndex: "100",
              }}
            >
              <IconButton onClick={handleDrawerToggle}>
                <ArrowForwardIosIcon />
              </IconButton>
            </div>
            {renderMenuItems()}
          </div>{" "}
        </Drawer>
      ) : (
        <div
          className={styles.drawer}
          style={{
            borderRight: `1px ${theme.custom.neutralColors.color2} solid`,
          }}
        >
          {renderMenuItems()}
        </div>
      )}
    </>
  );
};

export default SidePanel;
